var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOphthalmology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M27.739,29.075H4.819 c-0.97,0-1.756-0.786-1.756-1.756V5.601c0-0.97,0.786-1.756,1.756-1.756h22.92c0.97,0,1.756,0.786,1.756,1.756V27.32 C29.495,28.289,28.709,29.075,27.739,29.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M5.462,14.601c0,0,5.233-5.927,11.935-5.447 c0,0,4.966-0.027,9.585,5.954c0,0,1.001,0.694-0.167,1.809c0,0-4.406,6.448-12.075,5.547c0,0-5.046-0.36-9.792-6.007 C4.948,16.456,4.247,15.882,5.462,14.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M21.891,15.785 c0,3.035-2.46,5.495-5.495,5.495S10.9,18.82,10.9,15.785c0-3.035,2.46-5.495,5.496-5.495S21.891,12.75,21.891,15.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M19.496,15.785c0,1.764-1.43,3.193-3.193,3.193c-1.764,0-3.193-1.43-3.193-3.193 c0-1.764,1.43-3.193,3.193-3.193C18.066,12.592,19.496,14.021,19.496,15.785z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M19.496,15.785c0,1.764-1.43,3.193-3.193,3.193c-1.764,0-3.193-1.43-3.193-3.193 c0-1.764,1.43-3.193,3.193-3.193C18.066,12.592,19.496,14.021,19.496,15.785z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M16.532,14.023 c0,0.812-0.659,1.471-1.471,1.471s-1.471-0.659-1.471-1.471c0-0.812,0.659-1.471,1.471-1.471S16.532,13.21,16.532,14.023z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "10.243,11.762 8.898,11.762 8.898,10.417 7.051,10.417 7.051,11.762 5.706,11.762  5.706,13.61 7.051,13.61 7.051,14.955 8.898,14.955 8.898,13.61 10.243,13.61  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M24.532,22.278c-0.108,0.322-0.287,0.618-0.534,0.859c-0.184,0.179-0.396,0.355-0.628,0.489 l2.349,2.333l1.251-1.26L24.532,22.278z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M26.077,19.261C24.906,12.57,16.285,12.6,15.161,19.3c-0.032,0.189-0.031,0.391,0.002,0.58 c1.171,6.692,9.793,6.661,10.916-0.039C26.111,19.652,26.111,19.449,26.077,19.261z M25.174,19.665 c-0.876,5.741-8.254,5.767-9.171,0.033c-0.015-0.092-0.015-0.194-0.001-0.286c0.876-5.742,8.254-5.768,9.171-0.033 C25.188,19.471,25.188,19.573,25.174,19.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M25.173,19.379 c-0.917-5.735-8.295-5.709-9.171,0.033c-0.014,0.092-0.014,0.194,0.001,0.286c0.917,5.735,8.295,5.708,9.171-0.033 C25.188,19.573,25.188,19.471,25.173,19.379z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M24.057,24.864l2.59,2.549c0.5,0.496,1.307,0.493,1.803-0.006c0.496-0.5,0.493-1.307-0.006-1.803 l-2.59-2.549L24.057,24.864z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOphthalmology);
export default __webpack_public_path__ + "static/media/ophthalmology.7e2cc07ff9d1bbd09c4a6b19e944317f.svg";
export { ForwardRef as ReactComponent };